import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import usePolling from "@/hooks/usePolling";
import { fmtDate } from "@/lib/utils";

const fmt = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

const TABS = [
  { key: "", label: "All" },
  { key: "draft", label: "Drafts" },
  { key: "sent", label: "Sent" },
  { key: "received", label: "Received" },
  { key: "approved", label: "Approved" },
  { key: "paid", label: "Paid" },
];

export default function VendorInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [tab, setTab] = useState("");
  const navigate = useNavigate();

  const load = () => api.get("/vendor/invoices", { params: tab ? { status: tab } : {} }).then((r) => setInvoices(r.data));
  usePolling(load, 20000);
  useEffect(() => { load(); }, [tab]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="p-6 md:p-8" data-testid="vendor-invoices-page">
      <h1 className="text-2xl font-extrabold tracking-tight">Invoices</h1>
      <p className="text-slate-500 text-sm mt-1">Invoices you've raised against contractor purchase orders. Create one from a PO's detail page when the order ships.</p>

      <div className="flex gap-1.5 mt-5 flex-wrap">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`invoice-tab-${t.key || "all"}`}
            className={`px-3 py-1.5 rounded-lg text-[12.5px] font-semibold ${tab === t.key ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="overflow-x-auto">
        <table className="w-full mt-5 text-[13px]" data-testid="vendor-invoices-table">
          <thead>
            <tr className="text-[11px] uppercase tracking-wide text-slate-400 font-semibold border-b border-slate-100">
              <th className="text-left py-2.5">Invoice #</th><th className="text-left py-2.5">PO #</th><th className="text-left py-2.5">Invoice Date</th><th className="text-left py-2.5">Due</th><th className="text-right py-2.5">Total</th><th className="text-left py-2.5 pl-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((inv) => (
              <tr key={inv.id} onClick={() => navigate(`/vendor/invoices/${inv.id}`)} className="cursor-pointer hover:bg-slate-50 border-b border-slate-50" data-testid={`invoice-row-${inv.invoice_number}`}>
                <td className="py-3 mono text-sky-600 font-medium">{inv.invoice_number}</td>
                <td className="py-3 mono text-slate-600">{inv.po_number || "—"}</td>
                <td className="py-3 text-slate-600">{fmtDate(inv.invoice_date)}</td>
                <td className="py-3 text-slate-600">{fmtDate(inv.due_date)}</td>
                <td className="py-3 text-right mono font-medium">{fmt(inv.total)}</td>
                <td className="py-3 pl-3"><StatusBadge status={inv.status} /></td>
              </tr>
            ))}
            {invoices.length === 0 && (
              <tr><td colSpan={6} className="py-10 text-center text-slate-400 text-sm">No invoices{tab ? ` with status "${tab}"` : " yet — open a purchase order and choose Create Invoice"}.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
